import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const ScalesStroke48: FC<IconProps> = ({
  size = 48,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path d="M38.6693 23.1553L25.2669 26.7471C25.9749 26.8871 26.6362 27.3023 27.0482 28.0156L30.1175 33.333C31.1453 35.1103 29.8617 37.3329 27.8099 37.333H21.6683C19.6152 37.3329 18.3325 35.1102 19.3587 33.333L22.43 28.0156C22.5806 27.7571 22.7697 27.5463 22.9749 27.3623L11.3802 30.4697L10.7952 28.2783L38.0843 20.9648L38.6693 23.1553ZM20.9749 35.0664H28.5013L24.7376 28.5488L20.9749 35.0664ZM16.4632 13.3223C17.8779 12.9436 19.3498 13.7917 19.7298 15.209L21.1097 20.3584C21.4882 21.7756 20.6385 23.2464 19.2239 23.625L14.0726 25.0059C12.6566 25.3845 11.186 24.5351 10.806 23.1191L9.4261 17.9688C9.04743 16.5527 9.89682 15.0818 11.3128 14.7031L16.4632 13.3223ZM11.512 16.9941L13.0989 22.9189L19.0218 21.3311L17.4349 15.4072L11.512 16.9941ZM30.1351 9.33398C33.3749 9.33399 36.001 11.9618 36.0013 15.2002C36.0013 18.4389 33.3751 21.0674 30.1351 21.0674C26.8951 21.0674 24.2689 18.4389 24.2689 15.2002C24.2691 11.9618 26.8952 9.33398 30.1351 9.33398ZM30.1351 11.5996C28.1498 11.5996 26.5356 13.214 26.5355 15.1992C26.5355 17.1846 28.1497 18.7988 30.1351 18.7988C32.1204 18.7988 33.7347 17.1845 33.7347 15.1992C33.7346 13.214 32.1204 11.5996 30.1351 11.5996Z" fill={color}/>
      </svg>
    </IconContainer>
  );
};
